<template>
  <div :class="['multi-upload-wrap', `${page_style}`, {'no-submit': isSuccess}, {'has-result': !isNew}]">
    <div :class="['status-wrap', {'ing': isIng}, {'success': isSuccess}, {'fail': isFailed}]" v-if="!isNew">
      <p>{{formItem.field_result}}</p>
    </div>
    <div v-for="(item, i) in uploadList" :key="i" class="upload-item">
      <upload-card
        :idx="i"
        :form-item="item"
        @form-update="photoUpdate"></upload-card>
    </div>
    <div class="info-input" v-if="formItem.input">
      <p class="input-title">{{inputConfig.title}}</p>
      <p class="input-desc" v-html="inputConfig.desc"></p>
      <p v-if="this.formItem.is_upload_video === 1" class="input-ear" @click="showPopup('myPopup')">{{inputConfig.link_title}}</p>
      <cube-button v-if="videoShow" class="video-close-btn"><img src="../../../images/icon_close@2x.png" alt="" srcset=""></cube-button>
      <cube-popup type="my-popup" ref="myPopup" :visible="videoShow" @mask-click="closePopup('myPopup')">
        <video id="video-exam" controls="controls">
          <source :src="inputConfig.exam_video" type="video/mp4">
        </video>
      </cube-popup>
      <div v-if="examPicUrl" class="exam-pic">
        <img-v3 :src="examPicUrl" width="200" @click="showExamPic" />
        <scale ref="examPicRef" :img-url="examPicUrl"></scale>
      </div>
      <div v-for="(item, idx) in form" :key="idx" class="input-item">
        <component
          :is="getCom(item)"
          :form-item="item"
          :idx="idx"
          :page_style="isFleetPCFunnel ? page_style : ''"
          @form-update="formUpdate"
        ></component>
      </div>
    </div>
    <div class="btn-wrap" v-if="!isSuccess">
      <input
        type="button"
        :style="buttonStyle"
        :value="buttonTitle"
        :disabled="!canSubmit"
        @click="submitInfo"
      />
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { post } from "../../../tools/request";
import { showAlertDialog } from "../../../tools/Tip";
import Input from "../Input";
import {
  formatCPFBr,
  formatAccent,
  formatCURPMx,
  formatRUT,
  formatCURPCr,
  fireBase,
  compareVersions
} from "../../../tools/utils";
//默认单行选择
import DefaultSelect from "../default-select";
import UploadCard from "./detail-upload-card";
import scale from "../Scale.vue";
import { LOGIN_CONFIG } from "../../../tools/constant";
import { ends, SOURCE } from "../../../tools/constant";

export default {
  components: {
    Input,
    UploadCard,
    scale
  },
  props: [
    "auditConfig",
    "idx",
    "is_ocr",
    "dialogStyle",
    "page_type",
    "is_finished",
    "canUpload",
  ],
  data() {
    return {
      backConfig: {},
      popItem: {},
      // popVisible: false,
      form: [],
      uploadList: [],
      uploadData: {},
      uploadKey: '',
      uploadUrls: [],
      submitFlag: true,
      videoShow: false
    }
  },
  computed: {
    ...mapState(["_ticket", "_uuid", "_area"]),
    //传递过来整个对象
    formItem() {
      let c = this.isFleetPCFunnel ? this.auditConfig : this.$route.params.configs;
      return c || {};
    },
    page_style() {
      return this.$route.params.page_style || this.dialogStyle;
    },
    isFleetPCFunnel() {
      return ["h5_funnel_fleet_pc"].includes(this.page_style);
    },
    multi_select_photo() {
      return this.formItem['multi_select_photo'] || {};
    },
    inputConfig() {
      return this.formItem.input || {};
    },
    buttonConfig() {
      return this.formItem.button || {};
    },
    buttonColor() {
      return this.buttonConfig.button_color || {};
    },
    is_check_btn() {
      return this.buttonColor.is_check || {};
    },
    un_check_btn() {
      return this.buttonColor.un_check || {};
    },
    checkStatus() {
      return this.formItem.field_status;
    },
    isNew() {
      return this.formItem.field_status == 0;
    },
    isIng() {
      return this.formItem.field_status == 3;
    },
    isSuccess() {
      return this.formItem.field_status == 4;
    },
    isFailed() {
      return this.formItem.field_status == 5;
    },
    buttonTitle() {
      return this.canSubmit ? this.is_check_btn.title : this.un_check_btn.title;
    },
    buttonStyle() {
      return{
        color: this.canSubmit ? this.is_check_btn.text_color : this.un_check_btn.text_color,
        background: this.canSubmit ? this.is_check_btn.background_color : this.un_check_btn.background_color
      }
    },
    //检查form中每一项正确性,所有form 的input项必须valid为true
    validForm() {
      let needCheck = ["input"];
      return this.form
        .filter(x => needCheck.includes(x.type))
        .every(
          x => x.valid
        );
    },
    validUpload() {
      let needCheck = ["photo"];
      return this.uploadList
        .filter(x => needCheck.includes(x.type))
        .every(
          x => x.show_value.length
        );
    },
    canSubmit() {
      return this.validForm && (this.uploadList.length ? this.validUpload : true) && this.submitFlag;
    },
    examPicUrl() {
      let exam_pic_url = this.formItem.exam_pic_url;
      return Array.isArray(exam_pic_url) && exam_pic_url.length ? exam_pic_url[0] : '';
    },
    omegaItem() {
      let up = new URLSearchParams(location.search);
      let location_country = up.get("location_country");
      return {
        city_id: this._area.value || '',
        country_id: (LOGIN_CONFIG[location_country] || window.didii18nconfig[location_country]).country_id,
        driver_id: up.get("uid") || this._uuid + '',
        license_name: this.formItem.title
      }
    }
  },
  beforeCreate() {
    //一旦进入上传页，返回按钮就正常返回
    Fusion.resetBack &&
      Fusion.resetBack({
        reset: 2
      });
  },
  mounted() {
    if (this.isIng || this.isFailed) {
      this.submitFlag = false;
    }
    this.uploadList = (this.multi_select_photo.list || []).map(item => {
      return {
        ...item,
        field_status: this.formItem.field_status,
        field_result: this.formItem.field_result,
        document_enum: this.formItem.document_enum
      }
    });
    this.form = (this.inputConfig.form || []).map(item => {
      return {
        ...item,
        field_status: this.formItem.field_status,
        // field_result: this.formItem.field_result,
      }
    });
    Omega.trackEvent("ibt_onboarding_driver_license_submit_sw", "", this.omegaItem);
  },
  watch: {

  },
  methods: {
    formatCPFBr,
    formatAccent,
    formatCURPMx,
    formatRUT,
    formatCURPCr,
    getCom(item) {
      return {
        'input': Input,
        'select':DefaultSelect
      }[item.type];
    },
    //接收各组件发送的更新emit
    formUpdate(idx, action) {
      if (action !== "init") {
        this.submitFlag = true;
      }
      this.$set(this.form, idx, this.form[idx]);
      this.$emit("btn-update");
    },
    photoUpdate(idx) {
      this.submitFlag = true;
      this.$set(this.uploadList, idx, this.uploadList[idx]);
    },
    submitInfo() {
      Omega.trackEvent("ibt_onboarding_driver_license_submit_ck", "", this.omegaItem);
      if (this.canSubmit) {
        let up = new URLSearchParams(location.search);
        //兼容各个国家情况，vuex中如果存在ticket，则优先信任
        if (this._ticket) {
          up.set("ticket", this._ticket);
        }
        // @200903 多种类型上传组件, 外层透传radio选择类型 key,value
        if (this.formItem.radio_type_key) {
          up.append(this.formItem.radio_type_key, this.formItem.radio_type_value);
        }

        this.form.forEach(x => {
          if (x.key) {
            //检测是否需要清除格式
            let val = x.value;
            if (x.clear_format) {
              val = this[x.format](val, true);
            }
            up.append(x.key, val);
          }
        });
        this.uploadList.forEach(x => {
          if (x.key) {
            up.append(x.key, JSON.stringify(x.show_value));
          }
        });

        // @200908 支持资质过期 type|uid
        if (this.formItem.job_type) {
          up.append("job_type", this.formItem.job_type);
        }
        if (this.formItem.job_uid) {
          up.append("job_uid", this.formItem.job_uid);
        }

        let success = data => {
          if (this.formItem.need_next === 1) {
            this.$router.replace({ name: 'photoProgress' })
          } else {
            this.$router.replace({ name: "home" });
          }
        };
        post(process.env.ADD_AUDI_INFO, up)
          .then(success)
          .catch(err => {
            this.httpError(err);
            try {
              Omega.trackEvent("ibt_register_submit_review_error_ck", '', {
                path_url: process.env.ADD_AUDI_INFO,  //接口url
                message: JSON.stringify(err),  //全部返回信息
                request: up.toString(),  //请求参数信息
                errno: err.errno,  //报错码
              });
            } catch (e) {}
          });
      }
    },
    popUploadCb(data) {
      this.closeUploadImg();
    },
    httpError(res) {
      // this.toast.hide();
      showAlertDialog(this, res.errmsg);
    },
    showExamPic() {
      Omega.trackEvent("ibt_onboarding_driver_license_image_ck", "", this.omegaItem);
      this.$refs.examPicRef.show();
    },
    showPopup(refId) {
      const query = new URLSearchParams(location.search);
      const app_version = query.get("appversion");
      const bundle_id = query.get("bundle_id");

      if (ends.inApp && ends.isAndroid) {
        if (([SOURCE.fleetApp, SOURCE.fleet].includes(bundle_id) && compareVersions(app_version, '7.3.32') === -1) || ([SOURCE.global, SOURCE.globalIos, SOURCE.br_99, SOURCE.global_au].includes(bundle_id) && ["7.6.90", "7.6.94"].includes(app_version))) {
          Fusion.openPage && Fusion.openPage({
            url: this.formItem.input.exam_video,
            newWindow: true,
            target: "native",
            browser: true
          });
          return false;
        }
      }

      const component = this.$refs[refId]
      component.show()
      let examVideo = document.getElementById("video-exam");
      examVideo.play();
      Omega.trackEvent("ibt_onboarding_ear_ck", "", this.omegaItem);
    },
    closePopup(refId) {
      const component = this.$refs[refId]
      component.hide()
      let examVideo = document.getElementById("video-exam");
      examVideo.pause();
    }
  }
};
</script>
<style lang="scss" scoped>
@mixin wrap {
  width: 100%;
  margin-bottom: 0.32rem;
  padding: 0.4rem 0.32rem;
  box-sizing: border-box;
  background: #ffffff;
}
@mixin title {
  font-size: 0.44rem;
  line-height: 0.56rem;
  color: #0F1928;
  font-weight: 500;
}
.multi-upload-wrap {
  padding-bottom: 1.72rem;
  // &.has-result {
  //   padding-top: 1rem;
  // }
  &.no-submit {
    padding-bottom: 0;
  }
  .status-wrap {
    position: sticky;
    // position: fixed;
    width: 100%;
    top: 0;
    left: 0;
    z-index: 1;
    padding: 0.3rem 0.32rem;
    box-sizing: border-box;
    font-size: 0.32rem;
    color: #ffffff;
    &.ing {
      background: #91A0B4;
    }
    &.success {
      background: #18C47C;
    }
    &.fail{
      background: #FF525D;
    }
  }
  // .upload-item {
  //   @include wrap;
  //   > p {
  //     @include title;
  //   }
  //   .img-wrap {
  //     position: relative;
  //     display: flex;
  //     align-items: center;
  //     justify-content: center;
  //     width: 100%;
  //     height: 3.6rem;
  //     margin-top: 0.32rem;
  //     background: rgba(145,160,180,0.15);
  //     border-radius: 0.04rem;
  //   }
  //   .exam-pic {
  //     // width: 4.08rem;
  //     max-width: 4.53rem;
  //     height: 3.2rem;
  //   }
  //   .pop-icon {
  //     position: absolute;
  //     right: 0;
  //     bottom: 0;
  //     width: 0.58rem;
  //     height: 0.58rem;
  //   }
  //   .upload-btn {
  //     width: fit-content;
  //     margin: 0.4rem auto 0;
  //     line-height: 1px;
  //     text-align: center;
  //     > img {
  //       width: 0.46rem;
  //       height: 0.4rem;
  //       margin-right: 0.2rem;
  //       vertical-align: middle;
  //     }
  //     > span {
  //       line-height: 0.56rem;
  //       font-size: 0.36rem;
  //       vertical-align: middle;
  //     }
  //   }
  // }
  .info-input {
    @include wrap;
    .input-title {
      @include title;
    }
    .input-desc {
      margin-top: 0.24rem;
      line-height: 0.36rem;
      font-size: 0.28rem;
      color: #666666;
    }
    .input-ear {
      margin-top: 0.12rem;
      line-height: 0.36rem;
      font-size: 0.28rem;
      color: #ff7226;
    }
    .exam-pic {
      display: flex;
      justify-content: center;
      margin-top: 0.4rem;
    }
    .input-item {
      margin-top: 0.4rem;
      .container {
        background: rgba(145,160,180,0.15);
        border-radius: 0.12rem;
      }
    }
    .input-wraper {
      background: rgba(145,160,180,0.15);
      padding: 0 0.32rem;
      margin-bottom: 0;
      border-radius: 0.12rem;
      ::v-deep input {
        width: 100%;
        background: transparent;
      }
    }

    .video-close-btn {
      position: absolute;
      top: .2rem;
      left: .1rem;
      z-index: 999;
      font-size: .24rem;
      img {
        width: 0.48rem;
      }
    }

    #video-exam {
      width: 100%;
      height: 100%;
    }

    ::v-deep .cube-popup-mask {
      opacity: 0.95;
    }
  }
  .btn-wrap {
    position: fixed;
    width: 100%;
    bottom: 0;
    left: 0;
    padding: 0.32rem;
    box-sizing: border-box;
    background: #ffffff;
    > input{
      display: block;
      width: 100%;
      height: 1.08rem;
      line-height: 1.08rem;
      text-align: center;
      font-size: 0.36rem;
      font-weight: 500;
      border-radius: 0.04rem;
    }
  }
  &.h5_funnel_fleet_pc {
    padding-bottom: 80px;
    .status-wrap {
      position: relative;
      padding: 8px 16px;
      margin-bottom: 20px;
      font-size: 14px;
      line-height: 16px;
      font-weight: 500;
      &.success {
        color: #00CCAA;
        background: rgba(0,204,170,0.1);
      }
      &.error {
        color: #FF4060;
        background: rgba(255,64,96,0.1);
      }
    }
    .info-input {
      padding: 0 40px;
      .input-title {
        font-size: 18px;
        text-align: center;
        line-height: 22px;
      }
      .input-desc {
        font-size: 14px;
        color: #999999;
        line-height: 20px;
      }
      .input-item {
        margin-top: 20px;
        .container {
          background: transparent;
          padding: 0;
          // line-height: 1;
          ::v-deep .info-arrow {
            position: relative;
            top: 5px;
          }
        }
      }
      .input-wraper {
        background: transparent;
        padding: 0;
        // margin-bottom: 0;
        // border-radius: 0.12rem;
        ::v-deep input {
          width: 100%;
          background: transparent;
        }
      }
    }
    .btn-wrap {
      display: flex;
      justify-content: flex-start;
      flex-direction: row-reverse;
      position: absolute;
      height: 80px;
      padding: 24px;
      box-shadow: none;
      text-align: right;
      > input {
        width: auto;
        display: inline-block;
        padding: 6px 16px;
        box-sizing: border-box;
        height: 32px;
        line-height: 20px;
        font-size: 14px !important;
        font-weight: 500;
        border-radius: 4px;
        vertical-align: middle;
        &.btn-reUpload {
          color: #333;
          background: #fff;
          border: 1px solid #999;
        }
        &.btn-submit {
          color: #000;
          background: #ffe600;
        }
      }
    }
  }
}

</style>
